export default "__VITE_ASSET__h33wnoxa__"